import React from 'react';
import FormElementSelector from 'components/FormElementSelector';
import {
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock
} from 'react-bootstrap';
import PropTypes from 'prop-types';

const FormElement = props => {
  if (!props.show) return null;

  return (
    <FormGroup controlId={props.id} validationState={props.validationState}>
      <Col componentClass={ControlLabel} sm={4} md={3}>
        {props.label}:
      </Col>
      <Col sm={6} md={5}>
        <FormElementSelector {...props} />
        <FormControl.Feedback />
        {props.validationState && (
          <HelpBlock>{props.validationMessage}</HelpBlock>
        )}
      </Col>
    </FormGroup>
  );
};

FormElement.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  show: PropTypes.bool,
  editable: PropTypes.bool
};

FormElement.defaultProps = {
  validationState: null,
  validationMessage: '',
  id: '',
  label: '',
  value: '',
  show: true,
  editable: true
};

export default FormElement;



// WEBPACK FOOTER //
// ./src/components/FormElement.js